const navbarVue = () => import('../lib/components/lima-navbar.vue');
const mainVue = () => import('./main/main.vue');
const accountLoginVue = () => import('./account/account-login.vue');
const accountSettingVue = () => import('./account/account-setting.vue');
const userVue = () => import('./user/user.vue');
const userGroupVue = () => import('./user/user-group.vue');
const systemStatusVue = () => import('./system/system-status.vue');
const systemSettingVue = () => import('./system/system-setting.vue');
const systemEventLogVue = () => import('./system/system-event-log.vue');
const layout = () => import('./pages/layout.vue');

const routes = [];

routes.push({path:'/', components:{nav:navbarVue, default:mainVue}, meta:{title:'NAVIGATION.HOME'}});
routes.push({path:'/login', components:{nav:navbarVue, default:accountLoginVue}, meta:{title:'NAVIGATION.LOGIN', public:true}});
routes.push({path:'/settings', components:{nav:navbarVue, default:accountSettingVue}, meta:{title:'NAVIGATION.SETTINGS'}});
routes.push({path:'/user', components:{nav:navbarVue, default:userVue}, meta:{title:'NAVIGATION.USERS', required:'UserManagement'}});
routes.push({path:'/userGroup', components:{nav:navbarVue, default:userGroupVue}, meta:{title:'NAVIGATION.USER_GROUPS', required:'UserManagement'}});
routes.push({path:'/system/status', components:{nav:navbarVue, default:systemStatusVue}, meta:{title:'NAVIGATION.SYSTEM_STATUS', required:'SystemMonitoring'}});
routes.push({path:'/system', components:{nav:navbarVue, default:systemSettingVue}, meta:{title:'NAVIGATION.SYSTEM_SETTINGS', required:'SystemManagement'}});
routes.push({path:'/system/event-log', components:{nav:navbarVue, default:systemEventLogVue}, meta:{title:'NAVIGATION.EVENT_LOG', required:'SystemManagement'}});

routes.push({path:'/layout/edit', components:{default:layout}, meta:{title:'NAVIGATION.EVENT_LOG', public:true }});

routes.push({path:'/*', redirect:'/'});

export default routes;
